export default {
    data: function () {
        return {
            traitTagOptions: [],

            emptyForm: {
                traitTags: [],
            }
        }
    },

    methods: {
        // Wird von ItemForm.js::openModal nach dem Befüllen des Formulars gerufen:
        // bei neuen Datensätzen die Default-Werte der Tag-Kategorien vorbelegen
        afterDataLoadAddition: function () {
            if (this.form && this.form.id) {
                return;
            }
            const categories = (this.options && this.options.traitTagCategories) || [];
            categories.forEach(category => {
                // defaultValue ist ein Array (Legacy: einzelner String)
                const defaults = Array.isArray(category.defaultValue)
                    ? category.defaultValue
                    : (category.defaultValue ? [category.defaultValue] : []);
                if (!defaults.length || !Array.isArray(this.form.traitTags)) {
                    return;
                }
                const hasCategoryValue = this.form.traitTags.some(
                    tag => (category.valueList || []).includes(tag)
                );
                if (!hasCategoryValue) {
                    defaults.forEach(value => {
                        if (!this.form.traitTags.includes(value)) {
                            this.form.traitTags.push(value);
                        }
                    });
                }
            });
        },
    },
}
